import React from 'react';
import { PropTypes } from 'prop-types';
import { useField } from 'formik';
import classnames from 'classnames';
import styled from 'styled-components';

import Asterisk from '@atoms/Asterisk/index';
import TooltipInfo from '@atoms/TooltipInfo/TooltipInfo';
import LoadingInline from '@molecules/LoadingInline'; // TODO: should an atom reference a molecule?
import { BodySmall, LabelLarge } from '@styled';
import colors from '@general/colors';

const TextInputStyled = styled.input`
    border: 1px solid ${colors.lightGray};

    &[disabled] {
        background-color: ${colors.ultraLightGray};
        color: ${colors.darkGray};
    }
`;

const TextInput = ({ label, infoText, isLoading, shouldAutoFocus, ...props }) => {
    const [field, meta] = useField(props);

    // eslint-disable-next-line no-unused-vars
    const { id, name, required, validate } = props;
    const hasError = meta.touched && meta.error;
    const groupClasses = classnames('form-group', { 'has-danger': hasError });
    const inputClasses = classnames('form-control', 'p-3', { 'form-control-danger': hasError });

    return (
        <>
            <div className={groupClasses}>
                {label && (
                    <label className="flex" htmlFor={id || name}>
                        <LabelLarge>
                            {label} {required && <Asterisk />}
                        </LabelLarge>

                        {infoText && (
                            <span className="ml-0.25rem">
                                <TooltipInfo text={infoText} />
                            </span>
                        )}
                    </label>
                )}

                {isLoading && <LoadingInline />}
                {!isLoading && (
                    <>
                        <TextInputStyled className={inputClasses} {...field} autoFocus={shouldAutoFocus} {...props} />
                        {hasError && <BodySmall className="mt-0.25rem text-error">{meta.error}</BodySmall>}
                    </>
                )}
            </div>
        </>
    );
};

TextInput.propTypes = {
    label: PropTypes.string,
    infoText: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    required: PropTypes.bool,
    isLoading: PropTypes.bool,
    validate: PropTypes.func,
    shouldAutoFocus: PropTypes.bool,
};

export default TextInput;
